export const YOUTUBE_API = process.env.REACT_APP_YOUTUBE_API || '';
export const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || '';
